import { useMutation, useQuery } from "@tanstack/react-query"
import { cancelProgramBookingStatusWebByCancelProgramBookingStatusRequest, getProgramBookingWebByProgramBookingId } from "../../../../../../service/program";
import { cancelProgramBooking } from "../../../../../../service/programBooking";
import dayjs from "dayjs";

const checkBookingAvailableStatus = (programPeriod: [string, string], bookingPeriod: [string, string]) => {
    const [startProgram, endProgram] = programPeriod.map(q => dayjs(q))
    const [startBooking, endBooking] = bookingPeriod.map(q => dayjs(q))

    if (dayjs().isBefore(startBooking)) {
        return '오픈예정';
    } else if (dayjs().isAfter(startBooking) && dayjs().isBefore(endBooking)) {
        return '예약가능';
    } else if (dayjs().isAfter(endBooking)) {
        return '예약마감';
    } else if (dayjs().isAfter(endProgram)) {
        return '프로그램 종료';
    } else {
        return '-';
    }
}

const useGetProgramBookingWebByProgramBookingId = (id: number, responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['useGetProgramBookingWebByProgramBookingId', id, responseQuery],
        queryFn: () => getProgramBookingWebByProgramBookingId(id, responseQuery),
        enabled: !!id,
        select: res => res.data.data.getProgramBookingWebByProgramBookingId,
    });
    return query;
}

const useCancelProgramBookingStatusWebByCancelProgramBookingStatusRequest = () => {
    const mutation = useMutation({
        mutationFn: cancelProgramBookingStatusWebByCancelProgramBookingStatusRequest,
    });

    return mutation;
}

const useCancelProgramBooking = (callback: Function) => {
    const mutation = useMutation({
        mutationFn: cancelProgramBooking,
        onSuccess: (res) => { res.data && callback(res) }
    });
    return mutation;
}

export { checkBookingAvailableStatus, useGetProgramBookingWebByProgramBookingId, useCancelProgramBookingStatusWebByCancelProgramBookingStatusRequest, useCancelProgramBooking };